import Splide from '@splidejs/splide';

export default function initHomeHero() {
  const hero = document.querySelector('.js-home-hero-slider');

  if (!hero) return;

  const slider = new Splide(hero, {
    type: 'loop',
    autoplay: true,
    interval: 12000,
    speed: 850,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: false,
    pagination: true,
    keyboard: 'global',
    reducedMotion: {
      speed: 0,
      autoplay: 'pause',
    },
  });

  const clearSlideMotion = () => {
    hero.querySelectorAll('.is-hero-entering, .is-product-entering').forEach((slide) => {
      slide.classList.remove('is-hero-entering', 'is-product-entering');
    });
  };

  const startSlideMotion = (slide) => {
    if (!slide) return;

    slide.classList.add('is-hero-entering');

    if (slide.querySelector('.c-home-hero__product')) {
      slide.classList.add('is-product-entering');
    }
  };

  slider.on('mounted', () => {
    const initialSlide = slider.Components.Slides.getAt(slider.index);
    startSlideMotion(initialSlide ? initialSlide.slide : null);
  });

  slider.on('move', (newIndex, previousIndex, destinationIndex) => {
    clearSlideMotion();

    const destinationSlide = slider.Components.Slides.getAt(destinationIndex)
      || slider.Components.Slides.getAt(newIndex);

    startSlideMotion(destinationSlide ? destinationSlide.slide : null);
  });

  slider.mount();
}
